import SpeciesTraitList from "./SpeciesTraitList";

export default SpeciesTraitList;
export { SpeciesTraitList };
